import { Component, OnInit, ViewChild, OnChanges, Input, ElementRef, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { Chart } from 'chart.js'


export interface DataSetModel {
	label: any,
	backgroundColor?: string | string[],
	data: any,
	borderColor?: string | string[],
	fill?: boolean,
	showLine?: boolean,
	borderWidth?: number | number[]
}

export interface DoughnutChartModel {
	labels: any[],
	datasets: DataSetModel[]
}
export interface DoughnutOptionsModel {
	title?: {
		display: boolean,
		text: string,
		position?: string,
		fontColor?: string,
		fontSize?: number
	},
	maintainAspectRatio?: boolean,
	animation?: {
		duration?: number // general animation time
		onProgress?: Function,
		onComplete?: Function
	},
	hover?: {
		animationDuration?: number // duration of animations when hovering an item
	},
	responsiveAnimationDuration?: number,
	disablePointerEvents?: boolean,
	tooltips?: {
		callbacks?: {
			label?: Function
		},
		enabled?: boolean;
	},
	legend?: {
		display?: boolean,
		position?: string,
		labels?: {
			fontColor?: string,
			fontSize?: number
		}
	},
	cutoutPercentage?: number
	elements?: {
		center?: {
			text: string,
			color?: string, // Default is #000000
			fontStyle?: string, // Default is Arial
			sidePadding?: number, // Default is 20 (as a percentage)
			minFontSize?: number, // Default is 20 (in px), set to false and text will not wrap.
			lineHeight?: number // Default is 25 (in px), used for when text wraps
		}
	},
	layout?: {
		padding: {
			left: number,
			right: number,
			top: number,
			bottom: number
		}
	}
}


@Component({
	selector: 'app-doughnut-chart',
	templateUrl: './doughnut-chart.component.html',
	styleUrls: ['./doughnut-chart.component.scss']
})
export class DoughnutChartComponent implements OnInit, OnChanges {

	@Input() chartData: DoughnutChartModel;
	@Input() chartOptions: DoughnutOptionsModel;
	@ViewChild('doughnutChart') doughnutChart: ElementRef;
	constructor(
		private renderer2: Renderer2,
		private cdref: ChangeDetectorRef
	) { }

	ngOnInit(): void {
	}

	ngOnChanges(changes) {
		this.cdref.detectChanges();
		const doughnutCanvas: any = this.doughnutChart.nativeElement.getContext('2d');
		if (changes.chartData && this.doughnutChart && (changes.chartData.currentValue || changes.chartOptions && changes.chartOptions.currentValue)) {
			//To draw text inside Doughnut chart
			Chart.pluginService.register({
				beforeDraw: function (chart) {
					if (chart.config.options.elements.center) {
						// Get ctx from string
						const ctx = chart.chart.ctx;

						// Get options from the center object in options
						const centerConfig = chart.config.options.elements.center;
						const fontStyle = centerConfig.fontStyle || 'Arial';
						const txt = centerConfig.text;
						const color = centerConfig.color || '#000';
						const maxFontSize = centerConfig.maxFontSize || 75;
						const sidePadding = centerConfig.sidePadding || 20;
						const sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)
						// Start with a base font of 30px
						ctx.font = "30px " + fontStyle;

						// Get the width of the string and also the width of the element minus 10 to give it 5px side padding
						const stringWidth = ctx.measureText(txt).width;
						const elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

						// Find out how much the font can grow in width.
						const widthRatio = elementWidth / stringWidth;
						const newFontSize = Math.floor(30 * widthRatio);
						const elementHeight = (chart.innerRadius * 2);

						// Pick a new font size so it will not be larger than the height of label.
						let fontSizeToUse = Math.min(newFontSize, elementHeight, maxFontSize);
						let minFontSize = centerConfig.minFontSize;
						const lineHeight = centerConfig.lineHeight || 25;
						let wrapText = false;

						if (minFontSize === undefined) {
							minFontSize = 20;
						}

						if (minFontSize && fontSizeToUse < minFontSize) {
							fontSizeToUse = minFontSize;
							wrapText = true;
						}

						// Set font settings to draw it correctly.
						ctx.textAlign = 'center';
						ctx.textBaseline = 'middle';
						let centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
						let centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
						ctx.font = fontSizeToUse + "px " + fontStyle;
						ctx.fillStyle = color;

						if (!wrapText) {
							ctx.fillText(txt, centerX, centerY);
							return;
						}

						const words = txt.split(' ');
						let line = '';
						const lines = [];

						// Break words up into multiple lines if necessary
						for (let n = 0; n < words.length; n++) {
							const testLine = line + words[n] + ' ';
							const metrics = ctx.measureText(testLine);
							const testWidth = metrics.width;
							if (testWidth > elementWidth && n > 0) {
								lines.push(line);
								line = words[n] + ' ';
							} else {
								line = testLine;
							}
						}

						// Move the center up depending on line height and number of lines
						centerY -= (lines.length / 2) * lineHeight;

						for (let n = 0; n < lines.length; n++) {
							ctx.fillText(lines[n], centerX, centerY);
							centerY += lineHeight;
						}
						//Draw text in center
						ctx.fillText(line, centerX, centerY);
					}
				}
			});

			let doughnutChart = new Chart(doughnutCanvas, {
				type: 'doughnut',
				data: this.chartData,
				options: this.chartOptions
			});
			// To disable pointer Events when scroll
			if (this.chartOptions.hasOwnProperty('disablePointerEvents')) {
				if (this.chartOptions.disablePointerEvents) {
					this.renderer2.setStyle(doughnutCanvas, 'pointer-events', 'none');
				}
			}

		}
	}

}
